export const SET_AUTH = "setAuth";
export const PURGE_AUTH = "purgeAuth";
export const SET_PERMISSIONS = "setPermissions";

export const SET_NOTIFICATION = "setNotification";
export const SET_LOADING = "setLoading";

export const SET_TOKEN = "setToken";
export const SET_PAGE_HEADER = "setPageHeader";

export const GET_MAX_TARGET_SCORE_PENDING = "getMaxTargetScorePending";
export const GET_MAX_TARGET_SCORE_FULFILLED = "getMaxTargetScoreFulfilled";
export const GET_MAX_TARGET_SCORE_REJECTED = "getMaxTargetScoreRejected";
export const SET_MAX_TARGET_SCORE = "setMaxTargetScore";

export const GET_CAN_VIEW_PEERS_PENDING = "getCanViewPeersPending";
export const GET_CAN_VIEW_PEERS_REJECT = "getCanViewPeersReject";
export const GET_CAN_VIEW_PEERS_FULFILLED = "getCanViewPeersFulfilled";
export const SET_CAN_VIEW_PEERS = "setCanViewPeers";

export const GET_TARGETS_HISTORY_FULFILLED = "getTargetsHistoryFullFulfilled";
export const SET_HISTORY_SEARCH_QUERY = "setHistorySearchQuery";

export const SET_TARGET_SETTINGS_USERS_FULFILLED =
  "setTargetSettingsUsersFulfilled";
export const SET_TARGET_SETTINGS_USERS_LOADING =
  "setTargetSettingsUsersLoading";

export const SET_MEMBER_POSITIONS_FULFILLED = "setMemberPositionsFulfilled";

export const SET_IS_DISPATCHED_AVAILABLE_HEADS =
  "setIsDispatchedAvailableHeads";
export const SET_AVAILABLE_HEADS = "setAvailableHeads";
export const SET_IS_SHOW_PERSONAL_FILES_MOBILE = "setIsShowPersonalFilesMobile";
